module.exports = __webpack_public_path__ + "img/Frente-5-02 open.49f5933f.jpg";